// src/services/supplierService.js
import api from './api';

const supplierService = {
  // GET /proveedores with filters and pagination
  async listar(filtros = {}, orden = 'id', dir = 'DESC', limit = 20, offset = 0) {
    const params = { filtros, orden, dir, limit, offset };
    const res = await api.get('/proveedores', { params });
    const payload = res.data || {};
    const inner = payload.data || {};
    const rows = inner.data || [];
    const total = inner.total ?? 0;
    const lim = inner.limit ?? limit;
    const off = inner.offset ?? offset;
    return { data: rows, total, limit: lim, offset: off };
  },

  // GET /proveedores/{id}
  async obtener(id) {
    const res = await api.get(`/proveedores/${id}`);
    return res.data?.data || null;
  },

  // POST /proveedores
  async crear(payload) {
    const res = await api.post('/proveedores', payload);
    return res.data;
  },

  // PUT /proveedores/{id}
  async actualizar(id, payload) {
    const res = await api.put(`/proveedores/${id}`, payload);
    return res.data;
  },

  // DELETE /proveedores/{id}
  async eliminar(id) {
    const res = await api.delete(`/proveedores/${id}`);
    return res.data;
  }
};

export default supplierService;